module.exports = __webpack_public_path__ + "static/media/Bulk_freight_master_update_file.7a2c6c33.csv";